import http, {makeSearchParams} from 'utils/http';

export const getCertificationBodies = (queries) => {
  return http('GET', 'cb', makeSearchParams(queries));
};

export const getPublicCertificationBody = (id) => {
  return http('GET', `g/cb/${id}`);
};

export const getPublicCertificationBodies = (queries) => {
  return http('GET', 'g/cb', makeSearchParams(queries));
};

export const getPublicCBStandards = (cbId, queries) => {
  return http('GET', `g/cb/cb-standards/${cbId}`, makeSearchParams(queries));
};

export const getPublicCBStandardsByEconomy = (cbId, queries) => {
  return http(
    'GET',
    `g/cb-economy-standards/${cbId}`,
    makeSearchParams(queries)
  );
};

export const getPublicCBStandardsBySector = (cbId, queries) => {
  return http(
    'GET',
    `g/cb-scheme-sector-standards/${cbId}`,
    makeSearchParams(queries)
  );
};

export const getPublicCBStandardsByLocation = (cbId, queries) => {
  return http(
    'GET',
    `g/cb-location-standards/${cbId}`,
    makeSearchParams(queries)
  );
};

export const getPublicCBEconomyByAB = (cbId, queries) => {
  return http('GET', `g/cb-economy-by-ab/${cbId}`, makeSearchParams(queries));
};

export const getPublicEconomyByCbId = (cbId) => {
  return http('GET', `/g/cb-economy/${cbId}`);
};

/**
 * Public Sectors Scheme List.
 * it includes AB and Scheme
 * @param cbId
 * @param queries
 */
export const getPublicCBSectorSchemes = (cbId, queries) => {
  return http('GET', `g/cb-sector-scheme/${cbId}`, makeSearchParams(queries));
};

/**
 * Get certification bodies who has standards.
 * @param queries
 * @returns {*}
 */
export const getCertificationBodiesHasStandards = (queries) => {
  return http('GET', 'cb/has-standards', makeSearchParams(queries));
};

export const getPublicCBLocations = (cbId, queries) => {
  return http('GET', `g/cb/${cbId}/locations`, makeSearchParams(queries));
};

export const getPublicCBSectors = (cbId, queries) => {
  return http('GET', `g/cb-sector-list/${cbId}`, makeSearchParams(queries));
};

// CB Report Stats in Dashboard
export const getCBReport = (data) => {
  return http('GET', 'cb/report', makeSearchParams(data));
};
